<template>
    <div>
        <div class="container -todo">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Contrats dissociés</li>
            </ol>

            <div>
                <h1>Contrats dissociés</h1>
            </div>

            <div class="main-content">
                <table v-if="contractList.length" class="table table-hover">
                    <tr>
                        <th>Numéro de contrat</th>
                        <th>Nom</th>
                        <th>Date de souscription</th>
                        <th>Statut</th>
                        <th></th>
                    </tr>

                    <tr v-for="contract of contractList" :key="contract.id">
                        <td>{{ contract.external_id }}</td>
                        <td>{{ contract.first_name }} {{ contract.last_name }}</td>
                        <td>{{ formatDate(contract.date_signature) }}</td>
                        <td>{{ getState(contract) }}</td>
                        <td>
                            <a
                                v-link="{
                                        name: 'unlinked-contracts-detail',
                                        params: {
                                            id: contract.external_id,
                                        },
                                    }"
                                class="btn btn-primary btn-sm">
                                Consulter
                            </a>

                        </td>
                    </tr>
                </table>

                <div v-if="!contractList.length && !loading" class="empty-list jumbotron" v-else>
                    <h2>Aucun contrat dissocié</h2>
                </div>
            </div>

            <loader v-if="loading" class="bigger-loader"></loader>

            <div class="load-more">
                <a href="#"
                   v-if="hasNext && !loading"
                   v-on:click.prevent="updateFullList(true)"
                   class="btn btn-default">
                    Charger plus
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped type="text/less" lang="less">
@import "../style/variables";
/**
 * General styles.
 */
.main-content {
    margin-top: 50px;
}

/**
* Table styles.
 */
.table {
    margin: 5rem auto;

    tr {
        .btn {
            text-transform: none;
        }
    }
}
</style>

<script>
import moment from 'moment';
import {makeUpdateList} from '../utils';
import {listAll, fetchParameters} from '../api/unlinked_contracts';

export default {
    data() {
        return {
            states: {
                'PRE-IMPORT': 'A traiter',
                'IMPORTING': 'Importation',
                'DONE': 'Validé'
            },
            contractList: [],
            params: {},
            hasNext: false,
            page: 1,
            loading: true
        };
    },

    async ready() {
        await this.updateFullList();
        this.params = await fetchParameters();
    },

    methods: {
        updateFullList: makeUpdateList({
            loading: 'loading',
            page: 'page',
            hasNext: 'hasNext',
            list: 'contractList',
            fetch: async function (page) {
                return await listAll(
                    page, this.state, this.operation, this.dateStart, this.dateStop
                );
            }
        }),

        /**
         * Returns readable value for the automation type coming from the API.
         */
        getState(contract) {
            if (this.params.states) {
                return this.params.states.find(a => {
                    return a[0] === contract.state;
                })[1];
            }
            return null;
        },

        formatDate(date) {
            return moment(date, 'YYYY-MM-DD').format('L');
        }
    }
};

</script>



// WEBPACK FOOTER //
// UnlinkedContractsList.vue?02a3456c